import type { Difficulty, Settings } from './types';

export const BRAND = {
  appName: 'Lốc Cốc Typing Cannon',
  shortName: 'Lốc Cốc',
  tagline: 'Bắn từ vựng – Luyện phản xạ – Gõ nhanh hơn',
  version: '1.0.0',
} as const;

export const GAME_COLORS = {
  sky: '#1877d2',
  skyDeep: '#1258ad',
  navy: '#102752',
  white: '#fffdf2',
  yellow: '#ffd43b',
  yellowDeep: '#e49c00',
  red: '#ef4a35',
  redDeep: '#ad231e',
  cyan: '#65dcff',
  green: '#54c35a',
  greenDeep: '#197743',
  earth: '#b86b32',
  earthDark: '#753719',
} as const;

export const DIFFICULTIES: Record<Difficulty, { label: string; speed: number; spawnMs: number; maxWords: number; multiplier: number; lengths: [number, number]; vocabRange: [number, number] }> = {
  beginner: { label: 'Beginner', speed: 38, spawnMs: 2200, maxWords: 4, multiplier: 1, lengths: [3, 5], vocabRange: [1, 3] },
  easy: { label: 'Easy', speed: 48, spawnMs: 1900, maxWords: 5, multiplier: 1.05, lengths: [3, 7], vocabRange: [2, 4] },
  normal: { label: 'Normal', speed: 60, spawnMs: 1600, maxWords: 6, multiplier: 1.15, lengths: [4, 9], vocabRange: [3, 6] },
  hard: { label: 'Hard', speed: 73, spawnMs: 1350, maxWords: 7, multiplier: 1.3, lengths: [5, 12], vocabRange: [5, 8] },
  expert: { label: 'Expert', speed: 90, spawnMs: 1120, maxWords: 8, multiplier: 1.5, lengths: [6, 15], vocabRange: [7, 10] },
};

export const DEFAULT_SETTINGS: Settings = {
  showVisual: true, showMeaning: true, pronounceWord: true, autoPauseOnBlur: true,
  screenShake: true, reducedMotion: false, masterVolume: 0.8, uiScale: 1,
  highContrast: false, weakWordPriority: true,
};
